import React from "react";
import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { ArrowRight, Bell } from "lucide-react";

export default function NewsMarquee({ notices = [] }) {
  if (!notices.length) return null;
  return (
    <div
      data-testid="news-marquee"
      className="bg-brand-accent border-y border-brand-primary/10"
    >
      <div className="flex items-stretch">
        <div className="bg-brand-primary text-white px-4 py-3 flex items-center gap-2 flex-shrink-0">
          <Bell className="w-4 h-4 text-brand-secondary" />
          <span className="text-xs font-semibold tracking-[0.2em] uppercase">
            Notices
          </span>
        </div>
        <div className="flex-1 overflow-hidden">
          <Marquee speed={40} gradient={false} pauseOnHover>
            <div className="flex items-center gap-12 py-3">
              {notices.map((n) => (
                <span
                  key={n.id}
                  className="text-brand-primary font-serif text-lg whitespace-nowrap flex items-center gap-3"
                >
                  {n.is_urgent && (
                    <span className="inline-block px-2 py-0.5 text-[10px] uppercase tracking-wider bg-brand-tertiary text-white rounded-full">
                      Urgent
                    </span>
                  )}
                  <span className="font-semibold">{n.title}</span>
                  <span className="text-brand-muted text-base">- {n.content}</span>
                  <span className="text-brand-secondary px-4">|</span>
                </span>
              ))}
            </div>
          </Marquee>
        </div>
        <Link
          to="/notices"
          className="hidden sm:flex bg-white/70 text-brand-primary px-4 py-3 items-center gap-2 text-sm font-semibold hover:bg-white transition-colors border-l border-brand-primary/10"
          data-testid="view-all-notices"
        >
          View all <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
